/* UNDR v5 — Brand JavaScript — Fixed Build */
(function(){
'use strict';

/* ─────────────────────────────────────────
   GLOBAL: Cart refresh
───────────────────────────────────────── */
function refreshCartDrawer(callback){
  fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
    .then(function(r){return r.json();})
    .then(function(cart){
      var body    = document.getElementById('cart-drawer-body');
      var totalEl = document.getElementById('cart-drawer-total');
      var countEl = document.getElementById('cart-drawer-count');
      var foot    = document.getElementById('cart-drawer-foot');
      var headCount = document.querySelector('.cart-drawer__count');

      document.querySelectorAll('[data-cart-count]').forEach(function(el){
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      if(cart.item_count === 0){
        if(body) body.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="var(--c-border-mid)" stroke-width="1"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          '<p class="u-label u-muted">The layer is waiting.</p>' +
          '<a href="/collections" class="u-btn u-btn-ghost-gold u-btn-sm">Continue shopping</a>' +
          '</div>';
        if(foot) foot.style.display = 'none';
        if(headCount) headCount.style.display = 'none';
        if(countEl) countEl.style.display = 'none';
      } else {
        if(body){
          var html = '';
          cart.items.forEach(function(item, idx){
            var imgHtml = item.image
              ? '<img src="' + item.image.replace(/(\?.*)?$/, '?width=160') + '" alt="' + escHtml(item.title) + '" loading="lazy" width="72" height="90">'
              : '';
            var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
              ? '<div class="cart-item__variant">' + escHtml(item.variant_title) + '</div>'
              : '';
            html +=
              '<div class="cart-item" data-cart-key="' + escHtml(item.key) + '" data-cart-line="' + (idx + 1) + '">' +
              '<div class="cart-item__img">' + imgHtml + '</div>' +
              '<div class="cart-item__info">' +
              '<div class="cart-item__name">' + escHtml(item.product_title) + '</div>' +
              variantHtml +
              '<div class="cart-item__row">' +
              '<div class="cart-item__qty" data-cart-qty-wrap>' +
              '<button class="cart-item__qty-btn" data-cart-qty-action="dec" aria-label="Decrease quantity">&#8722;</button>' +
              '<span class="cart-item__qty-val" data-cart-qty-val>' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-cart-qty-action="inc" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="cart-item__price" data-cart-item-price>' + formatMoneyFromCents(item.line_price) + '</span>' +
              '</div>' +
              '</div>' +
              '</div>';
          });
          body.innerHTML = html;
          bindCartQtyListeners();
        }
        if(totalEl) totalEl.textContent = formatMoneyFromCents(cart.total_price);
        if(foot) foot.style.display = '';
        if(countEl){ countEl.textContent = cart.item_count; countEl.style.display = ''; }
        if(headCount){ headCount.textContent = cart.item_count; headCount.style.display = ''; }
      }
      if(typeof callback === 'function') callback(cart);
    })
    .catch(function(err){ console.error('UNDR cart refresh failed:', err); });
}
window.UNDR_refreshCart = refreshCartDrawer;

function ajaxAddToCart(variantId, quantity, callback){
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body:JSON.stringify({id:parseInt(variantId),quantity:parseInt(quantity)||1})
  })
  .then(function(r){return r.json();})
  .then(function(data){
    if(data.status && data.status >= 400){
      if(typeof callback === 'function') callback(null, data.description || 'Could not add to cart.');
    } else {
      refreshCartDrawer(function(){
        var co = document.getElementById('cart-ov');
        if(co){ co.classList.add('open'); document.body.style.overflow = 'hidden'; }
        if(typeof callback === 'function') callback(data, null);
      });
    }
  })
  .catch(function(){
    if(typeof callback === 'function') callback(null, 'Something went wrong.');
  });
}
window.UNDR_addToCart = ajaxAddToCart;

function escHtml(str){
  return String(str||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

function formatMoneyFromCents(cents){
  if(window.Shopify && typeof window.Shopify.formatMoney === 'function'){
    return window.Shopify.formatMoney(cents, window.UNDR_MONEY_FORMAT || '{{amount_with_comma_separator}} €');
  }
  var fmt = window.UNDR_MONEY_FORMAT || '';
  if(!fmt) return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  var amount = (cents / 100).toFixed(2);
  var amountComma = amount.replace('.', ',');
  var amountNoDecimals = Math.round(cents / 100).toString();
  return fmt
    .replace('{{amount}}', amount)
    .replace('{{amount_with_comma_separator}}', amountComma)
    .replace('{{amount_no_decimals}}', amountNoDecimals)
    .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals);
}
window.UNDR_formatMoney = formatMoneyFromCents;

/* ── Scroll reveal ── */
function initReveal(){
  var els=document.querySelectorAll('.u-reveal');
  if(!els.length)return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}
    });
  },{threshold:0.1,rootMargin:'0px 0px -40px 0px'});
  els.forEach(function(el){io.observe(el);});
}

/* ── Sticky header ── */
function initHeader(){
  var h=document.getElementById('site-header');
  var ann=document.getElementById('ann-bar-inner');
  if(!h)return;
  var annH=ann?ann.offsetHeight:0;
  function update(){
    var scrolled=window.scrollY>80;
    h.classList.toggle('scrolled',scrolled);
    if(ann){h.style.top=scrolled?'0':annH+'px';}
  }
  window.addEventListener('scroll',update,{passive:true});
  window.addEventListener('resize',function(){annH=ann?ann.offsetHeight:0;update();},{passive:true});
  update();
}

/* ── Mobile nav ── */
function initMobileNav(){
  var btn=document.getElementById('nav-burger');
  var nav=document.getElementById('mobile-nav');
  if(!btn||!nav)return;
  function toggle(open){
    nav.classList.toggle('open',open);
    btn.setAttribute('aria-expanded',String(open));
    document.body.style.overflow=open?'hidden':'';
  }
  btn.addEventListener('click',function(){toggle(!nav.classList.contains('open'));});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')toggle(false);});
  var swipeStartX=0;
  nav.addEventListener('touchstart',function(e){swipeStartX=e.touches[0].clientX;},{passive:true});
  nav.addEventListener('touchend',function(e){
    if(e.changedTouches[0].clientX-swipeStartX<-60)toggle(false);
  },{passive:true});
}

/* ── Cart drawer ── */
function initCart(){
  var ov      = document.getElementById('cart-ov');
  var backdrop = document.getElementById('cart-backdrop');
  var closeBtn = document.getElementById('cart-close');
  if(!ov) return;

  function openCart(){
    ov.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart(){
    ov.classList.remove('open');
    document.body.style.overflow = '';
  }

  window.UNDR_openCart  = openCart;
  window.UNDR_closeCart = closeCart;

  document.querySelectorAll('[data-open-cart]').forEach(function(b){
    b.addEventListener('click', function(e){
      if(e.target.closest('[data-cart-checkout]')) return;
      openCart();
    });
  });

  if(backdrop){
    backdrop.addEventListener('click', function(){
      closeCart();
    });
  }

  if(closeBtn){
    closeBtn.addEventListener('click', closeCart);
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && ov.classList.contains('open')) closeCart();
  });

  var dragHandle = ov.querySelector('.cart-drawer__head');
  if(dragHandle){
    var swipeStartY = 0;
    dragHandle.addEventListener('touchstart', function(e){
      swipeStartY = e.touches[0].clientY;
    }, {passive: true});
    dragHandle.addEventListener('touchend', function(e){
      if(e.changedTouches[0].clientY - swipeStartY > 80) closeCart();
    }, {passive: true});
  }
}

/* ── Size guide ── */
function initSizeGuide(){
  var ov=document.getElementById('sg-ov');
  var openBtns=document.querySelectorAll('[data-open-sg]');
  var closeBtn=document.getElementById('sg-close');
  if(!ov)return;
  function toggle(open){ov.classList.toggle('open',open);document.body.style.overflow=open?'hidden':'';}
  openBtns.forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();toggle(true);});});
  if(closeBtn)closeBtn.addEventListener('click',function(){toggle(false);});
  ov.addEventListener('click',function(e){if(e.target===ov)toggle(false);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')toggle(false);});
}

/* ── Email popup ── */
function initPopup(){
  var ov=document.getElementById('kpop-ov');
  if(!ov)return;
  if(sessionStorage.getItem('undr_pop'))return;
  function hide(){ov.classList.remove('open');document.body.style.overflow='';sessionStorage.setItem('undr_pop','1');}
  function show(){ov.classList.add('open');document.body.style.overflow='hidden';}
  setTimeout(show,30000);
  var cb=document.getElementById('kpop-close');
  var sk=document.getElementById('kpop-skip');
  if(cb)cb.addEventListener('click',hide);
  if(sk)sk.addEventListener('click',hide);
  ov.addEventListener('click',function(e){if(e.target===ov)hide();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')hide();});
  var form=document.getElementById('kpop-form');
  if(form){
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : '';
      var submitBtn = form.querySelector('[type="submit"]');
      if(!email) return;
      if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Joining...'; }
      var params = new URLSearchParams();
      params.append('form_type','customer');
      params.append('utf8','\u2713');
      params.append('contact[email]', email);
      params.append('contact[tags]','newsletter,the-base');
      fetch('/contact',{
        method:'POST',
        headers:{'Content-Type':'application/x-www-form-urlencoded','X-Requested-With':'XMLHttpRequest'},
        body:params.toString()
      }).then(function(){
        form.innerHTML='<p style="color:var(--c-gold);font-family:var(--f-head);letter-spacing:.08em;text-align:center;padding:20px 0;font-size:14px;">Welcome to The Base.</p>';
        setTimeout(hide,2000);
      }).catch(function(){
        form.innerHTML='<p style="color:var(--c-gold);font-family:var(--f-head);letter-spacing:.08em;text-align:center;padding:20px 0;font-size:14px;">Welcome to The Base.</p>';
        setTimeout(hide,2000);
      });
    });
  }
}

/* ── Cart qty buttons ── */
function bindCartQtyListeners(){
  document.querySelectorAll('[data-cart-qty-wrap]').forEach(function(w){
    if(w.dataset.qtyBound) return;
    w.dataset.qtyBound = '1';
    var disp = w.querySelector('[data-cart-qty-val]');
    var item = w.closest('.cart-item');
    w.querySelectorAll('[data-cart-qty-action]').forEach(function(b){
      b.addEventListener('click',function(){
        var n = parseInt(disp.textContent) || 1;
        if(b.dataset.cartQtyAction==='dec') n = Math.max(0, n-1);
        if(b.dataset.cartQtyAction==='inc') n++;
        disp.textContent = n;
        if(n === 0 && item) item.style.opacity = '0.4';
        w.querySelectorAll('button').forEach(function(x){ x.disabled = true; });
        var key  = item ? item.dataset.cartKey  : null;
        var line = item ? parseInt(item.dataset.cartLine) : null;
        if(!key && !line){ refreshCartDrawer(); return; }
        fetch('/cart/change.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body: JSON.stringify(key ? {id:key,quantity:n} : {line:line,quantity:n})
        })
        .then(function(r){ return r.json(); })
        .then(function(){ refreshCartDrawer(); })
        .catch(function(){ refreshCartDrawer(); });
      });
    });
  });
}

function initQty(){
  document.querySelectorAll('[data-qty-wrap]').forEach(function(w){
    if(w.dataset.qtyBound) return;
    w.dataset.qtyBound = '1';
    var val=w.querySelector('[data-qty-val]');
    var hiddenInput = document.getElementById('pdp-qty');
    w.querySelectorAll('[data-qty-action]').forEach(function(b){
      b.addEventListener('click',function(){
        var n=parseInt(val ? val.textContent : 1)||1;
        if(b.dataset.qtyAction==='dec') n=Math.max(1,n-1);
        if(b.dataset.qtyAction==='inc') n=Math.min(99,n+1);
        if(val) val.textContent=n;
        if(hiddenInput) hiddenInput.value=n;
      });
    });
  });
  bindCartQtyListeners();
}

/* ── Compression bars ── */
function initCompression(){
  var fills=document.querySelectorAll('[data-comp-fill]');
  if(!fills.length)return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){e.target.style.width=e.target.dataset.compFill||'60%';io.unobserve(e.target);}
    });
  },{threshold:0.3});
  fills.forEach(function(f){f.style.width='0';io.observe(f);});
}

/* ── Filter pills ── */
function initFilters(){
  document.querySelectorAll('[data-filter-group]').forEach(function(g){
    var pills=g.querySelectorAll('[data-filter-pill]');
    pills.forEach(function(p){
      p.addEventListener('click',function(){
        pills.forEach(function(x){x.classList.remove('active');});
        p.classList.add('active');
      });
    });
  });
}

/* ── INIT ── */
function init(){
  initReveal();
  initHeader();
  initMobileNav();
  initCart();
  initSizeGuide();
  initPopup();
  initQty();
  initCompression();
  initFilters();
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
}else{
  init();
}
})();